import { jsx as a } from "react/jsx-runtime";
import { c as m } from "../../../index-Cu0xwYjD.js";
import "../../providers/IconsProvider.js";
import { usePictograms as p } from "../../providers/PictogramsProvider.js";
import "react";
import "../../../ThemeContext-CvPyrdCo.js";
import '../../../assets/Pictogram.css';const e = "_pictogram_8i99i_4", g = {
  pictogram: e
}, x = ({
  name: t,
  size: o = "64px",
  className: i,
  ...s
}) => {
  const c = p(), r = t && c[t];
  return r ? /* @__PURE__ */ a(
    r,
    {
      "data-testid": `element-pictogram${t ? `-${t}` : ""}`,
      "data-icon": t,
      width: o,
      height: o,
      focusable: "false",
      "aria-hidden": "true",
      className: m(g.pictogram, i),
      ...s
    }
  ) : null;
};
export {
  x as Pictogram
};
